<template>
  <router-link :to="to" style="text-decoration: none"
    ><v-sheet
      color="#F4F4F4"
      style="border: 1px solid #8d8d8d"
      class="rounded-lg pa-5"
      ><slot />
      </v-sheet
    ></router-link
  >
</template>
<script>
export default {
  props: {
    to: {
      type: [String, Object],
      default: "/",
    },
  }
}
</script>